import React from 'react';
import styled from 'styled-components';
import { Box } from 'grid-styled';
import { FormattedMessage } from 'react-intl';

import Container from 'components/Container';
import { FONT_FAMILIES } from 'config';
import Button from '../../../Button';

const APPLIST = [{
  name: 'buy.c2cx',
  title: 'skycoin-0.27.0-cli-linux-arm',
  url: 'https://downloads.skycoin.com/wallet/skycoin-0.27.0-cli-linux-arm.tar.gz',
  color: '#0072FF',
}, {
  name: 'buy.cryptopia',
  title: 'skycoin-0.27.0-cli-linux-x64',
  url: 'https://downloads.skycoin.com/wallet/skycoin-0.27.0-cli-linux-x64.tar.gz',
  color: '#0072FF',
}, {
  name: 'buy.cryptopia',
  title: 'skycoin-0.27.0-cli-osx-darwin-x64',
  url: 'https://downloads.skycoin.com/wallet/skycoin-0.27.0-cli-osx-darwin-x64.zip',
  color: '#0072FF',
}, {
  name: 'buy.cryptopia',
  title: 'skycoin-0.27.0-cli-win-x64',
  url: 'https://downloads.skycoin.com/wallet/skycoin-0.27.0-cli-win-x64.zip',
  color: '#0072FF',
}, {
  name: 'buy.cryptopia',
  title: 'skycoin-0.27.0-cli-win-x86',
  url: 'https://downloads.skycoin.com/wallet/skycoin-0.27.0-cli-win-x86.zip',
  color: '#0072FF',
}, {
  name: 'buy.cryptopia',
  title: 'skycoin-0.27.0-daemon-linux-arm',
  url: 'https://downloads.skycoin.com/wallet/skycoin-0.27.0-daemon-linux-arm.tar.gz',
  color: '#0072FF',
}, {
  name: 'buy.cryptopia',
  title: 'skycoin-0.27.0-daemon-linux-x64',
  url: 'https://downloads.skycoin.com/wallet/skycoin-0.27.0-daemon-linux-x64.tar.gz',
  color: '#0072FF',
}, {
  name: 'buy.cryptopia',
  title: 'skycoin-0.27.0-daemon-osx-darwin-x64',
  url: 'https://downloads.skycoin.com/wallet/skycoin-0.27.0-daemon-osx-darwin-x64.zip',
  color: '#0072FF',
}, {
  name: 'buy.cryptopia',
  title: 'skycoin-0.27.0-daemon-win-x64',
  url: 'https://downloads.skycoin.com/wallet/skycoin-0.27.0-daemon-win-x64.zip',
  color: '#0072FF',
}, {
  name: 'buy.cryptopia',
  title: 'skycoin-0.27.0-daemon-win-x86',
  url: 'https://downloads.skycoin.com/wallet/skycoin-0.27.0-daemon-win-x86.zip',
  color: '#0072FF',
}, {
  name: 'buy.cryptopia',
  title: 'skycoin-0.27.0-gui-electron-linux-x64',
  url: 'https://downloads.skycoin.com/wallet/skycoin-0.27.0-gui-electron-linux-x64.AppImage',
  color: '#0072FF',
}, {
  name: 'buy.cryptopia',
  title: 'skycoin-0.27.0-gui-electron-osx',
  url: 'https://downloads.skycoin.com/wallet/skycoin-0.27.0-gui-electron-osx.dmg',
  color: '#0072FF',
}, {
  name: 'buy.cryptopia',
  title: 'skycoin-0.27.0-gui-electron-win-setup',
  url: 'https://downloads.skycoin.com/wallet/skycoin-0.27.0-gui-electron-win-setup.exe',
  color: '#0072FF',
}, {
  name: 'buy.cryptopia',
  title: 'skycoin-0.27.0-gui-standalone-linux-arm',
  url: 'https://downloads.skycoin.com/wallet/skycoin-0.27.0-gui-standalone-linux-arm.tar.gz',
  color: '#0072FF',
}, {
  name: 'buy.cryptopia',
  title: 'skycoin-0.27.0-gui-standalone-linux-x64',
  url: 'https://downloads.skycoin.com/wallet/skycoin-0.27.0-gui-standalone-linux-x64.tar.gz',
  color: '#0072FF',
}, {
  name: 'buy.cryptopia',
  title: 'skycoin-0.27.0-gui-standalone-osx-darwin-x64',
  url: 'https://downloads.skycoin.com/wallet/skycoin-0.27.0-gui-standalone-osx-darwin-x64.zip',
  color: '#0072FF',
}, {
  name: 'buy.cryptopia',
  title: 'skycoin-0.27.0-gui-standalone-win-x64',
  url: 'https://downloads.skycoin.com/wallet/skycoin-0.27.0-gui-standalone-win-x64.zip',
  color: '#0072FF',
}, {
  name: 'buy.cryptopia',
  title: 'skycoin-0.27.0-gui-standalone-win-x86',
  url: 'https://downloads.skycoin.com/wallet/skycoin-0.27.0-gui-standalone-win-x86.zip',
  color: '#0072FF',
}];

const Cover = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 40vh;
  padding-bottom: 4rem;

  p {
    font-family: ${FONT_FAMILIES.sans};
    color: #394049;
  }
`;

const DownloadsForms = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  min-height: 10px;
  width: 100%;

  p {
    font-family: ${FONT_FAMILIES.sans};
    color: #394049;
  }
`;

const DownloadsSelect = styled.select`
  height: 40px;
  font-size: 1rem;
  font-family: ${FONT_FAMILIES.sans};
  border: 1px solid transparent;
  background-color: #EBF3FD;
`;

const DownloadsParagraph = styled.p`
  padding-top: 2rem;
  a {
    color: #0072FF;
    text-decoration: none;
  }
`;

class WalletList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.getOS = this.getOS.bind(this);
    if (!this.tester) {
      this.tester = 'https://downloads.skycoin.com/wallet/skycoin-0.27.0-daemon-win-x86.zip';
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  getOS() {
    const userAgent = window.navigator.userAgent;
    const platform = window.navigator.platform;
    const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
    const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
    const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
    const os = null;
    this.tester = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
      this.tester = 'https://downloads.skycoin.com/wallet/skycoin-0.27.0-daemon-osx-darwin-x64.zip';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      this.tester = 'https://downloads.skycoin.com/wallet/skycoin-0.27.0-daemon-linux-arm.tar.gz';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      this.tester = 'https://downloads.skycoin.com/wallet/skycoin-0.27.0-daemon-win-x64.zip';
    } else if (/Android/.test(userAgent)) {
      this.tester = 'https://downloads.skycoin.com/wallet/skycoin-0.27.0-daemon-win-x86.zip';
    } else if (!os && /Linux/.test(platform)) {
      this.tester = 'https://downloads.skycoin.com/wallet/skycoin-0.27.0-daemon-linux-x64.tar.gz';
    }

    return os;
  }

  handleChange(event) {
    this.setState({ value: event.target.value });
    this.tester = this.state.value;
  }

  handleSubmit(event) {
    event.preventDefault();
  }

  render() {
    return (
      <div>
        <Container>
          <Cover>
            <DownloadsForms>
              <form onSubmit={this.handleSubmit}>
                <DownloadsSelect onChange={this.handleChange} value={this.tester}>
                  {APPLIST.map(({ title, color, url }, i) => (
                    <option
                      key={i}
                      m={1}
                      color="white"
                      bg={color}
                      fontSize={[1, 3]}
                      width={[1 / 1, 'auto']}
                      value={url}
                    >
                      <FormattedMessage id={title} />
                    </option>
                  ))}
                </DownloadsSelect>
                <Button
                  href={this.tester}
                  m={1}
                  color="white"
                  bg="#0072FF"
                  fontSize={[1, 3]}
                  target="_blank"
                  rel="noopener noreferrer"
                  width={[1 / 1, 'auto']}
                  download
                >
                  <FormattedMessage id="downloads" />
                </Button>
              </form>
            </DownloadsForms>
            <Box>
              <DownloadsParagraph>Learn more about Skywallet in <a rel="noopener noreferrer" href="https://s3-ap-southeast-1.amazonaws.com/downloads.skycoin.com/skywallet/Skywallet-User_Manuals_Draft_1_c.pdf" target="_blank">User Manuals</a>.</DownloadsParagraph>
            </Box>
          </Cover>
        </Container>
      </div>
    );
  }
}

export default WalletList;



// WEBPACK FOOTER //
// ./src/components/DownloadsDrafts/components/WalletList/WalletList.js